import xhr from '../utils/fetch';

export interface IRegistration {
  _id: string;
  studentName: string;
  parentName: string;
  phone: string;
  email: string;
  workshop: string;
  className: string;
  currency: string;
  paidAmount: string;
  createdAt: string;
  updatedAt: string;
}

const get = async (
  currentPage: number,
  resultsPerPage: number,
  filters: Record<string, string>,
  sortField: string,
  sortDir: string
): Promise<{ count: number; data: IRegistration[] }> => {
  const res = await xhr({
    url: '/a/registrations',
    method: 'GET',
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      sort: sortField,
      dir: sortDir,
      ...filters
    }
  });
  const body = res.data;
  if (Array.isArray(body)) {
    return { count: body.length, data: body };
  }
  if (body && Array.isArray(body.data)) {
    return { count: body.count ?? body.data.length, data: body.data };
  }
  return { count: 0, data: [] };
};

const getById = async (id: string): Promise<IRegistration> => {
  const res = await xhr({
    url: `/a/registrations/${id}`,
    method: 'GET'
  });
  return res.data;
};

const remove = async (id: string): Promise<void> => {
  await xhr({
    url: `/a/registrations/${id}`,
    method: 'DELETE'
  });
};

const workshopRegistrationsApi = {
  get,
  getById,
  remove
};

export default workshopRegistrationsApi;
